var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticClass:"mx-auto mt-5"},[_vm._v("404 - Seite Nicht gefunden")])])
}
var staticRenderFns = []

export { render, staticRenderFns }